module.exports = __webpack_public_path__ + "img/menu-bars.941884a3.svg";